import './index.scss';
import React from 'react';
import ClauseCell from './clause_cell';
import DecPageCell from './dec_page_cell';
const Cell = (props) => {
    const { cellId, rowIndex, classification, doc } = props;
    if (classification.category.key === 'clauses') {
        return React.createElement(ClauseCell, { cellId: cellId, clauseData: doc.data.clauses[classification.descriptor.key], descriptor: classification.descriptor, doc: doc, rowIndex: rowIndex });
    }
    return React.createElement(DecPageCell, { cellId: cellId, decPageFields: doc.data.decPageFields[classification.descriptor.key] || [], descriptor: classification.descriptor, doc: doc, rowIndex: rowIndex });
};
export default Cell;
